// extracted by mini-css-extract-plugin
export default {"download-file__container":"download-file_download-file__container__mptlY"};